var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.9 47.9",
    style: {
      enableBackground: "new 0 0 47.9 47.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,19.4c-5.7,0-10.9,2.9-13.9,7.7c-0.7,1.2-0.4,2.7,0.8,3.4c1.2,0.7,2.7,0.4,3.4-0.8 c2.1-3.4,5.7-5.4,9.6-5.4s7.5,2,9.6,5.4c0.5,0.8,1.3,1.2,2.1,1.2c0.5,0,0.9-0.1,1.3-0.4c1.2-0.7,1.5-2.3,0.8-3.4 C34.8,22.3,29.6,19.4,23.9,19.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5,21.1C42.4,12.9,33.6,8,23.9,8S5.5,12.9,0.4,21.1c-0.7,1.2-0.4,2.7,0.8,3.4c1.2,0.7,2.7,0.4,3.4-0.8 C8.8,17,16,13,23.9,13S39,17,43.2,23.7c0.5,0.8,1.3,1.2,2.1,1.2c0.5,0,0.9-0.1,1.3-0.4C47.9,23.8,48.2,22.2,47.5,21.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9,
    cy: 35.7,
    r: 4.1
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      opacity: 0.7
    },
    x1: 9.7,
    y1: 2.7,
    x2: 36.3,
    y2: 44.7
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.9a1e6dddc8492c3bc9c32ef46b3c527d.svg";
export { ForwardRef as ReactComponent };